// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile__pOrlU","overlay":"Tile_overlay__1Prsu"};